export const styles = {
  container: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    p: 4,
    maxHeight: '90vh',
    overflowY: 'auto',
  },
};
